module.exports = __webpack_public_path__ + "static/img/kcsys-address.ab712d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kcsys-address.png?20181011
// module id = r7jp
// module chunks = 1